<div class="relative w-full h-full">
  <google-map #map [width]="'100%'" [height]="'100%'" [options]="mapOptions()">
    @for (hairdresser of hairdressers(); track $index) {
    <map-advanced-marker #mapAdvancedMarker="mapAdvancedMarker" [position]="hairdresser.coordinates"
      [content]="customMarker" [title]="hairdresser.username || hairdresser.firstname"
      (mapClick)="openInfoWindow(mapAdvancedMarker, hairdresser)">
      <div #customMarker
        class="bg-marker w-8 h-9 bg-no-repeat bg-center flex items-center justify-center text-center text-white">
        <span class="-translate-y-0.5">{{ (hairdresser.username || hairdresser.firstname || '?').charAt(0) }}</span>
      </div>
    </map-advanced-marker>

    @if (userPosition()) {
    <map-advanced-marker [position]="userPosition()!" [content]="userMarker" title="User Position">
      <div #userMarker
        class="bg-[url(/icons/map-user-icon.svg)] w-8 h-10 bg-no-repeat bg-center flex items-center justify-center text-center text-white">
      </div>
    </map-advanced-marker>
    }
    }
    @if (selectedHairdresser()) {
    <map-info-window>
      <braidsbook-hairdresser-map-details [hairdresser]="selectedHairdresser()!" [distance]="distance()"
        [isCalculatingRoute]="isCalculatingRoute()" />
    </map-info-window>
    }
    @if (directionsResult()) {
    <map-directions-renderer [directions]="directionsResult()!" [options]="{
        polylineOptions: {
          strokeColor: '#ef4444',
          strokeWeight: 5,
          strokeOpacity: 0.8
        },
        suppressMarkers: true
      }" />
    }
  </google-map>
  <button (click)="requestUserLocation()" [disabled]="isRequestingLocation()"
    class="absolute bottom-[75px] right-2 z-10 bg-white rounded-full size-10 shadow-lg hover:bg-gray-50 transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
    [attr.title]="isRequestingLocation() ? ('MAP.REQUESTING_LOCATION' | translate) : ('MAP.REQUEST_LOCATION' | translate)">
    @if (isRequestingLocation()) {
    <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-primary"></div>
    } @else {
    <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="2" x2="5" y1="12" y2="12" />
      <line x1="19" x2="22" y1="12" y2="12" />
      <line x1="12" x2="12" y1="2" y2="5" />
      <line x1="12" x2="12" y1="19" y2="22" />
      <circle fill="none" cx="12" cy="12" r="7" />
      <circle fill="none" cx="12" cy="12" r="3" />
    </svg>
    }
  </button>
</div>